export default function headingWidget(editor) {
  editor.DomComponents.addType('eb-heading', {
    isComponent(el) {
      return el.getAttribute && el.getAttribute('data-gjs-type') === 'eb-heading'
    },
    model: {
      defaults: {
        tagName: 'h2',
        name: 'Heading',
        content: 'Your Heading Here',
        editable: true,
        droppable: false,
        attributes: { 'data-gjs-type': 'eb-heading' },
        style: {
          'font-size': '28px',
          'font-weight': '700',
          'color': '#333333',
          'margin': '0 0 15px 0',
          'line-height': '1.3',
        },
        traits: [
          {
            type: 'select',
            name: 'tagName',
            label: 'HTML Tag',
            changeProp: true,
            options: [
              { id: 'h1', label: 'H1' },
              { id: 'h2', label: 'H2' },
              { id: 'h3', label: 'H3' },
              { id: 'h4', label: 'H4' },
              { id: 'h5', label: 'H5' },
              { id: 'h6', label: 'H6' },
              { id: 'p', label: 'Paragraph' },
            ],
          },
          { type: 'text', name: 'id', label: 'CSS ID' },
        ],
      },
    },
  })

  editor.BlockManager.add('eb-heading', {
    label: 'Heading',
    category: 'Basic',
    media: '<svg viewBox="0 0 24 24"><path fill="currentColor" d="M5,4V7H10.5V19H13.5V7H19V4H5Z"/></svg>',
    content: { type: 'eb-heading' },
  })
}
